module.exports = __webpack_public_path__ + "media/feet_on_the_beach.9ab1ab35.mp3";